<template>
    <div>
        <!-- alpha fix- added class mt-5  -->
        <div class="row mt-5">
            <div class="col-sm-12">
                <a :href="$api_url+'/leave-attendances'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>
        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <div class="row clearfix mb-2"><div class="col-md-12">Click browse and upload file</div></div>
            <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
            <br />
            <div v-if='errormsg'>
                <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                <ul class="list-group ">
                    <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                </ul>
            </div>
        </b-overlay>
  </div>
</template>
<script>

    export default{
        mounted() {
            //alert(this.cu);
            this.upload_url = this.$api_url+"/contract/import";
        },
        data(){
            return {
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                upload_url : '',
                process_url : '',
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                uploaded_file_data : this.$api_url+"/device-mapping/import/update/processdata",
                imptimeout: false,
            }
        },
        methods:{

            uploadFile:function(event)
            {
                this.showoverlay = true;
                this.errormsg = [];
                this.empfile = event.target.files[0];
                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                this.upload_url = this.$api_url+"/device-mapping/import/update";
                this.uploaded_file_data = this.$api_url+"/device-mapping/import/update/processdata";
                var loc = this.$api_url+"/leave-attendances";
                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.showoverlay = false;

                        // this.$bvToast.toast('File uploaded.', {
                        //                     title: `Job on progress`,
                        //                     variant: 'info',
                        //                     solid: true
                        //                 });

                        //alert('Check this link to get the processed data: ' + this.uploaded_file_data);


                        axios.get(this.uploaded_file_data , {

                        }).then(function(response){

                            if(response.data.success == true)
                            {


                                this.$bvToast.toast(response.data.msg, {
                                            title: `Updated Successfully`,
                                            variant: 'info',
                                            solid: true
                                        });

                                window.location.href = loc;
                            }
                            else
                            {
                                this.$bvToast.toast(response.data.msg, {
                                            title: `Update Failed !`,
                                            variant: 'error',
                                            solid: true
                                        });

                            }



                        }.bind(this)).catch(function (error){
                        });


                        //window.location.href = this.uploaded_file_data;

                    }.bind(this)).
                    catch(function (error)
                            {
                                //alert(error.response.data.errors);
                            });
            },
        },
        created: function(){
            //this.setUrls();
        },

        computed:
        {

        }
    }
</script>
